import moment from 'moment';

export const costReg = /^0\.([1-9]|[0-9][1-9])$|(^([1-9][0-9]{0,5})(\.[0-9]||\.[0-9][0-9])?$)/;
export const skuPalletReg = /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/;
export const integerReg = /^([1-9][0-9]{0,4})$/;

const skuPalletValidator = (rule, value, callback) => {
    if (!skuPalletReg.test(value)) {
        callback('请输入0.01-100的拍数');
    } else {
        callback();
    }
};
const integerValidator = (rule, value, callback) => {
    if (!integerReg.test(value)) {
        callback('请输入1-99999的箱数');
    } else {
        callback();
    }
};

export const haveWiringColumns = [
    {
        title: '日期',
        dataIndex: 'planTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '预计送达时间',
        dataIndex: 'arriveTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '供应商',
        dataIndex: 'supplierCode',
        scopedSlots: { customRender: 'supplierCode' },
        width: 180
    },
    {
        title: '始发地',
        dataIndex: 'originalSupplier',
        customRender: (text) => text || '-',
        width: 120
    },
    {
        title: '区域',
        dataIndex: 'area',
        width: 120
    },
    {
        title: '仓库',
        dataIndex: 'warehouseCode',
        scopedSlots: { customRender: 'warehouseCode' },
        width: 180
    },
    {
        title: '最终目的地',
        dataIndex: 'originalDepot',
        customRender: (text) => text || '-',
        width: 180
    },
    {
        title: '拍数',
        dataIndex: 'skuPallet',
        width: 60
    },
    {
        title: '箱数',
        dataIndex: 'skuAmount',
        width: 60
    },
    {
        title: '拍数向上取整',
        dataIndex: 'skuPalletUpper',
        width: 120
    }
];

export const haveAllWiringColumns = [
    {
        title: '日期',
        dataIndex: 'planTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '预计送达时间',
        dataIndex: 'arriveTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '供应商',
        dataIndex: 'supplierCode',
        scopedSlots: { customRender: 'supplierCode' },
        width: 180
    },
    {
        title: 'D订单号',
        dataIndex: 'orderCode',
        scopedSlots: { customRender: 'orderCode' },
        customRender: (text) => text || '--',
        width: 200
    },
    {
        title: '始发地',
        dataIndex: 'originalSupplier',
        customRender: (text) => text || '--',
        width: 120
    },
    {
        title: '区域',
        dataIndex: 'area',
        width: 120
    },
    {
        title: '仓库',
        dataIndex: 'warehouseCode',
        scopedSlots: { customRender: 'warehouseCode' },
        width: 180
    },
    {
        title: '最终目的地',
        dataIndex: 'originalDepot',
        customRender: (text) => text || '--',
        width: 180
    },
    {
        title: '拍数',
        dataIndex: 'skuPallet',
        width: 60
    },
    {
        title: '箱数',
        dataIndex: 'skuAmount',
        width: 60
    },
    {
        title: '拍数向上取整',
        dataIndex: 'skuPalletUpper',
        width: 120
    }
];

const carList = [
    {
        value: '7.6米',
        label: '7.6米'
    },
    {
        value: '9.6米',
        label: '9.6米'
    },
    {
        value: '12.5米',
        label: '12.5米'
    },
    {
        value: '13.5米',
        label: '13.5米'
    },
    {
        value: '15米',
        label: '15米'
    }
];

export const carLengthList = carList;

export const notWiringColumns = [
    {
        title: '日期',
        dataIndex: 'planTime',
        customRender: (text) => (text ? moment(text).format('YYYY-MM-DD') : '--'),
        width: 120
    },
    {
        title: '集散中心',
        dataIndex: 'supplierCode',
        scopedSlots: { customRender: 'supplierCode' }
        // width:180
    },
    {
        title: '仓库',
        dataIndex: 'warehouseCode',
        scopedSlots: { customRender: 'warehouseCode' }
        // width:180
    },
    {
        title: '拍数',
        dataIndex: 'skuPallet',
        width: 140
    },
    {
        title: '箱数',
        dataIndex: 'skuAmount',
        width: 140
    },
    {
        title: '拍数向上取整',
        dataIndex: 'skuPalletUpper',
        width: 140
    }
    // {
    //   title:"未排线原因",
    //   dataIndex:"remark"
    // },
    // {
    //   title:"操作",
    //   dataIndex:"action",
    //   scopedSlots: { customRender: "action" },
    //   fixed:'right',
    //   width:120
    // }
];
// 排线编辑验证
export const EditWiringRules = {
    planTime: {
        RULES: [{ required: true, message: '请选择日期', trigger: 'change' }]
    },
    supplierCode: {
        RULES: [{ required: true, message: '请输入供应商', trigger: 'change' }]
    },
    warehouseCode: {
        RULES: [{ required: true, message: '请输入仓库', trigger: 'change' }]
    },
    skuPallet: {
        RULES: [
            { required: true, message: '请输入拍数', trigger: 'change' },
            { validator: skuPalletValidator, trigger: 'change' }
        ]
    },
    skuAmount: {
        RULES: [
            { required: true, message: '请输入箱数', trigger: 'change' },
            { validator: integerValidator, trigger: 'change' }
        ]
    }
};
// 编辑排线table
export const EditWiringColumns = [
    {
        title: '日期',
        dataIndex: 'planTime',
        key: 'planTime',
        scopedSlots: { customRender: 'planTime' },
        type: 'date',
        width: 160,
        prop: {}
    },
    {
        title: '供应商',
        key: 'supplierCode',
        dataIndex: 'supplierCode',
        scopedSlots: { customRender: 'supplierCode' },
        type: 'input',
        width: 160,
        prop: {
            maxLength: 100,
            placeholder: '请输入供应商'
        }
    },
    {
        title: '仓库',
        key: 'warehouseCode',
        dataIndex: 'warehouseCode',
        scopedSlots: { customRender: 'warehouseCode' },
        type: 'input',
        width: 160,
        prop: {
            maxLength: 100,
            placeholder: '请输入仓库'
        }
    },
    {
        title: '拍数',
        key: 'skuPallet',
        dataIndex: 'skuPallet',
        scopedSlots: { customRender: 'skuPallet' },
        type: 'numInput',
        width: 160,
        prop: {
            placeholder: '请输入拍数'
        }
    },
    {
        title: '箱数',
        key: 'skuAmount',
        dataIndex: 'skuAmount',
        scopedSlots: { customRender: 'skuAmount' },
        type: 'numInput',
        width: 160,
        prop: {
            placeholder: '请输入箱数'
        }
    },
    {
        title: '拍数向上取整',
        key: 'skuPalletUpper',
        dataIndex: 'skuPalletUpper',
        width: 120
    },
    {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        width: 80,
        align: 'center'
    }
];

// 排线类型
export const PLAN_STATUS = {
    TO_BE_PLAN: 'TO_BE_PLAN', // 未排线
    PLANED: 'PLANED', // 已排线
    DELETED: 'DELETED'
};

// 装载拍数
export const CAR_LENGTH_VOLUME = {
    '7.6米': 10,
    '9.6米': 14,
    '12.5米': 18,
    '13.5米': 20,
    '15米': 22
};

export const SearchFiled = [
    {
        label: '线路',
        name: 'line',
        type: 'input',
        prop: {
            placeholder: '请输入线路名称',
            maxLength: 100
        }
    },
    {
        label: '日期',
        name: 'createTime',
        type: 'date',
        prop: {
            showTime: {
                format: 'HH:mm:ss',
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
            },
            format: 'YYYY-MM-DD',
            placeholder: ['开始日期', '结束日期']
        }
    },
    {
        label: '是否为变更计划',
        name: 'isChanged',
        type: 'select',
        prop: {
            placeholder: '请选择',
            options: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: 1,
                    label: '是'
                },
                {
                    value: 0,
                    label: '否'
                }
            ]
        }
    },
    {
        label: '供应商',
        name: 'supplierCode',
        type: 'input',
        prop: {
            placeholder: '请输入供应商编码',
            maxLength: 100
        }
    },
    {
        label: '仓库',
        name: 'warehouseCode',
        type: 'input',
        prop: {
            placeholder: '请输入仓库编码',
            maxLength: 100
        }
    },
    {
        label: '车长',
        name: 'carLengths',
        type: 'select',
        prop: {
            placeholder: '请选择车长',
            mode: 'multiple',
            options: carList
        }
    },
    {
        label: '满载率达标',
        name: 'loadFactorIsRight',
        type: 'select',
        prop: {
            placeholder: '请选择满载率达标',
            options: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: true,
                    label: '是'
                },
                {
                    value: false,
                    label: '否'
                }
            ]
        }
    }
];
